

    /**
     * Typecast a value to a String, using an empty string value for null or
     * undefined.
     */
    function toString(val){
        return val == null ? '' : val.toString();
    }

    module.exports = toString;





//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/toString.js
// module id = 13
// module chunks = 0 1 2